export default __webpack_public_path__ + "674d315e6ccf630c73ddd4fe42ff9087.jpg";